// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Up7r","label":"styles_label__3UxK2"};